import axios from 'axios';
import { delay } from '@/helpers/promises';

const WAIT = 1000; // ms
const MAX_ATTEMPTS = 15 * 60; // 15 min

export default async function retryGet(url, trace, attempt = 1) {
  const res = await axios({
    method: 'GET',
    url,
  });
  const ifNoneMatch = new URL(url).searchParams.get('If-None-Match');
  const ETag = res.headers.etag;
  // S3 does not respect the condition. Check it here.
  if (typeof res.data !== 'object' || res.data.$placeholder !== undefined) {
    if (attempt >= MAX_ATTEMPTS) {
      throw new Error(`Failed to get KPI result: ${JSON.stringify(trace)}`);
    }
    await delay(WAIT);
    return retryGet(url, trace, attempt + 1);
  }
  if (ETag === ifNoneMatch) console.warn('[kpi]: if-none-match', ETag);

  return res;
}
